'use client'

import { Box, Typography, type SxProps, type Theme } from '@mui/material'
import { outfit } from '@/lib/fonts'
import {
  OPAS_BRAND_MARK_COLOR,
  OPAS_BRAND_MARK_ROTATE_DEG,
  OPAS_BRAND_MARK_SVG_PATH,
} from './opasBrand'

const ff = outfit.style.fontFamily

/** #201 — şeffaf zemin, yalnızca eğik kırmızı kare çerçeve */
export function OpasBrandMark({
  size = 44,
  color = OPAS_BRAND_MARK_COLOR,
  alt = 'OPAS',
  /** Görsel büyütme (layout kutusu aynı kalır) */
  visualScale = 1,
  sx,
}: {
  size?: number
  color?: string
  alt?: string
  visualScale?: number
  sx?: SxProps<Theme>
}) {
  return (
    <Box
      component="span"
      role="img"
      aria-label={alt}
      sx={{
        width: size,
        height: size,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        lineHeight: 0,
        overflow: 'visible',
        ...sx,
      }}
    >
      <Box
        component="span"
        sx={{
          width: size,
          height: size,
          display: 'block',
          transform: visualScale !== 1 ? `scale(${visualScale})` : undefined,
          transformOrigin: 'center center',
        }}
      >
        <svg viewBox="0 0 48 48" width="100%" height="100%" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
          <g transform={`rotate(${OPAS_BRAND_MARK_ROTATE_DEG} 24 24)`}>
            <path fill={color} fillRule="evenodd" clipRule="evenodd" d={OPAS_BRAND_MARK_SVG_PATH} />
          </g>
        </svg>
      </Box>
    </Box>
  )
}

export function OpasBrandLockup({
  markSize = 40,
  markColor = OPAS_BRAND_MARK_COLOR,
  wordmarkColor = 'currentColor',
  wordmark = 'OPAS',
  gap = 1.25,
  sx,
}: {
  markSize?: number
  markColor?: string
  wordmarkColor?: string
  wordmark?: string
  gap?: number
  sx?: SxProps<Theme>
}) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap, ...sx }}>
      <OpasBrandMark size={markSize} color={markColor} />
      <Typography
        sx={{
          fontFamily: ff,
          fontWeight: 800,
          fontSize: markSize * 0.52,
          letterSpacing: '0.12em',
          color: wordmarkColor,
          lineHeight: 1,
        }}
      >
        {wordmark}
      </Typography>
    </Box>
  )
}
